<template>
  <div class="container-fluid py-4 px-4">
    <div class="border border-1 rounded-3 p-3 mb-3 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-card-text display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            GESTION DE SOLICITUDES
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            BUSQUEDA DE INFORMACION
          </p>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <button v-if="permisoVisualizador == 6" class="btn  ms-1 mb-2" @click="descargarExcel" :class="{
        'btn btn border border-1 ms-2 bg-secondary text-white':
          !excelCarga,
        'btn btn-ligth border border-1 text-success ms-2':
          excelCarga,
      }" :disabled="!excelCarga" title="LISTADO DE PERSONAL A CONTRATAR">
        <i class="bi bi-filetype-xls"></i>
        <b v-if="!excelCarga">Cargando... </b>
      </button>

      <button v-if="permisoVisualizador == 6" @click="reporte" class="btn btn-primary ms-1 mb-2"
        title="ACTUALIZAR LISTADO EXCEL">
        <i class="bi bi-arrow-clockwise"></i>
      </button>

      <abbr title="LISTADO DE PERSONAL PARA PROGRAMACION EMPO"
        v-if="permisoVisualizador == 10 || permisoVisualizador == 9 || permisoVisualizador == 12">
        <button @click="descargarExcelBienestar" :class="{
          'btn btn border-dark border-1 ms-2 me-1 bg-secondary text-white ': !excelBien,
          'btn btn-light border-dark border-1 text-success ms-2 ': excelBien,
        }" :disabled="!excelBien">
          <i class="bi bi-filetype-xls"></i>
          <b v-if="!excelBien"> Cargando...</b>
        </button>
      </abbr>

      <abbr title="RECARGA DE REPORTE" v-if="permisoVisualizador == 10">
        <button @click="reporteBienestar" class="btn btn-ligth border border-1 text-primary ms-1 mb-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
            class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
            <path
              d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
          </svg>
        </button>
      </abbr>

      <button v-if="permisoVisualizador == 9 || permisoVisualizador == 12" @click="descargarExcelSST" :class="{
        'btn btn border-dark border-1 ms-2 bg-secondary text-white':
          !excelSst,
        'btn btn-ligth border-dark border-1 text-success ms-2':
          excelSst,
      }" :disabled="!excelSst" title="LISTADO DE PERSONAL SST">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-filetype-xls"
          viewBox="0 0 16 16">
          <path fill-rule="evenodd"
            d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM6.472 15.29a1.176 1.176 0 0 1-.111-.449h.765a.578.578 0 0 0 .254.384c.07.049.154.087.25.114.095.028.202.041.319.041.164 0 .302-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.255-.144-.462-.193l-.619-.143a1.72 1.72 0 0 1-.539-.214 1.001 1.001 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.527-.422.225-.1.484-.149.777-.149.305 0 .564.05.78.152.216.102.383.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.625.625 0 0 0-.247-.181.923.923 0 0 0-.369-.068c-.217 0-.388.05-.513.152a.472.472 0 0 0-.184.384c0 .121.048.22.143.3a.97.97 0 0 0 .405.175l.62.143c.217.05.406.12.566.211a1 1 0 0 1 .375.358c.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Zm-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94l1.274-2.007Zm2.727 3.325H4.557v-3.325h-.79v4h2.487v-.675Z" />
        </svg>
        <b v-if="!excelSst"> Cargando...</b>
      </button>

      <button v-if="permisoVisualizador == 9 " @click="descargarExcelInduccion" :class="{
        'btn btn border-dark border-1 ms-2 bg-secondary text-white':
          !excelInduccion,
        'btn btn-ligth border-dark border-1 text-success ms-2':
          excelInduccion,
      }" :disabled="!excelInduccion" title="Reporte_Induccion_Faltantes">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-filetype-xls"
          viewBox="0 0 16 16">
          <path fill-rule="evenodd"
            d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM6.472 15.29a1.176 1.176 0 0 1-.111-.449h.765a.578.578 0 0 0 .254.384c.07.049.154.087.25.114.095.028.202.041.319.041.164 0 .302-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.255-.144-.462-.193l-.619-.143a1.72 1.72 0 0 1-.539-.214 1.001 1.001 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.527-.422.225-.1.484-.149.777-.149.305 0 .564.05.78.152.216.102.383.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.625.625 0 0 0-.247-.181.923.923 0 0 0-.369-.068c-.217 0-.388.05-.513.152a.472.472 0 0 0-.184.384c0 .121.048.22.143.3a.97.97 0 0 0 .405.175l.62.143c.217.05.406.12.566.211a1 1 0 0 1 .375.358c.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Zm-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94l1.274-2.007Zm2.727 3.325H4.557v-3.325h-.79v4h2.487v-.675Z" />
        </svg>
        <b v-if="!excelInduccion"> Cargando...</b>
      </button>

    </div>

    <div class="border border-1 rounded-3 p-3 mb-3 ">

      <div v-if="!SolicitudCargar" class="d-flex justify-content-end mt-2">
        <span for="" class="input-group-text mt-3 buscar-estiloCuadrado"> <i class="bi bi-search"></i></span>
        <input class="form-control form-control-lg w-25 mt-3 me-2 buscar-estiloCuadrado" type="text"
          aria-label=".form-control-lg example" placeholder="POR SOLICITUD / SCC / ESTADO /ASIGNADO" v-model="busqueda"
          @input="Filtro" />
      </div>

      <div class="table-responsive mx-2 mt-2">

        <div v-if="SolicitudCargar" class="w-full overflow-hidden mx-2 mt-5">
          <b-row class="mt-1">
            <b-col cols="12" class="mt-5">
              <b-skeleton-img no-aspect height="380px"></b-skeleton-img>
            </b-col>
          </b-row>
        </div>

        <div v-if="!SolicitudCargar">

          <table class="table table-bordered" v-if="tabla1">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th scope="col"><i class="bi bi-boxes"></i></th>
                <th scope="col">N° SOL.</th>
                <th scope="col">ESTADO</th>
                <th scope="col">F.REGISTRO </th>
                <th scope="col">ASIGNADO A</th>
                <th scope="col">LUGAR</th>
                <th scope="col">EMPRESA</th>
                <th scope="col">CLIENTE</th>
                <th scope="col">PUESTO</th>
                <th scope="col">CANT.</th>
              </tr>
            </thead>
            <!-- .slice(NUM_RESULTS - 6, NUM_RESULTS) -->

            <tbody v-for="(post, index) in paginatedRespuesta" :key="index.id">
              <!-- v-if="filter(post)" -->
              <tr class="text-center align-middle reducirTamaño">

                <td scope="row" class="text-center tabla-estiloCompreso">
                  <div class="mx-2" @click="listado(post.idMaeSolicitud)">
                    <button class="btn btn-outline-success boton-estiloCuadrado">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                  </div>
                </td>

                <!-- 🔢 N° SOL -->
                <td class="fw-semibold text-dark text-center">
                  <i class="bi bi-file-earmark-text me-1"></i>
                  {{ post.idMaeSolicitud }}
                </td>

                <!-- 🚦 ESTADO -->
                <td>
                  <span class="fw-semibold text-center label-resaltado" :class="{
                    'text-warning': post.solEstado == '001',
                    'text-primary': post.solEstado == '002',
                    'text-success': post.solEstado == '003',
                    'text-danger': post.solEstado == '004',
                    'text-secondary': post.solEstado == '005'
                  }">
                    <i :class="{
                      'bi bi-hourglass-split': post.solEstado == '001',
                      'bi bi-check-circle': post.solEstado == '003',
                      'bi bi-clock-history': post.solEstado == '002',
                      'bi bi-x-circle': post.solEstado == '004',
                      'bi bi-slash-circle': post.solEstado == '005'
                    }"></i>
                    {{ post.desEstado }}
                  </span>
                </td>

                <!-- 📅 Fecha -->
                <td class="text-center">
                  <i class="bi bi-calendar-check me-1 text-muted"></i>
                  {{ post.solFecRegistro.slice(0, 10) }}
                </td>

                <!-- 👤 Asignado -->
                <td class="text-start">
                  <i class="bi bi-person-workspace me-1 text-secondary"></i>
                  {{ post.responSeleccion || '—' }}
                </td>

                <!-- 📍 Lugar -->
                <td class="text-center">
                  <i class="bi bi-geo-alt-fill me-1 text-danger"></i>
                  {{ post.desUbigeo }}
                </td>

                <!-- 🏢 Empresa -->
                <td class="text-start">
                  <i class="bi bi-building-fill me-1 text-primary"></i>
                  {{ post.centroCosto }}
                </td>

                <!-- 💼 Cliente -->
                <td class="text-start">
                  <i class="bi bi-people me-1 text-info"></i>
                  {{ post.subCentroCosto }}
                </td>

                <!-- 🎯 Puesto -->
                <td class="text-start">
                  <i class="bi bi-person-badge-fill me-1 text-success"></i>
                  {{ post.nomPuesto }}
                </td>

                <!-- 👥 Cantidad -->
                <td class="text-start">
                  <i class="bi bi-123 me-1 text-dark"></i>
                  {{ post.solCanPostulante }}
                </td>
              </tr>
            </tbody>
          </table>

          <!-- tabla2 -->

          <table class="table table-bordered" v-if="!tabla1">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th scope="col"><i class="bi bi-boxes"></i></th>
                <th scope="col">N° SOL.</th>
                <th scope="col">ESTADO</th>
                <th scope="col">F. REGISTRO</th>
                <th scope="col">ASIGNADO A</th>
                <th scope="col">LUGAR</th>
                <th scope="col">EMPRESA</th>
                <th scope="col">CLIENTE</th>
                <th scope="col">PUESTO</th>
                <th scope="col">CANT.</th>
              </tr>
            </thead>
            <!-- .slice(NUM_RESULTS - 6, NUM_RESULTS) -->

            <tbody v-for="(post, index) in paginatedRespuesta" :key="index.id">
              <!-- v-if="filter(post)" -->
              <tr class="text-center align-middle reducirTamaño">

                <td scope="row" class="text-center tabla-estiloCompreso">
                  <div class="mx-2" @click="listado(post.idMaeSolicitud)">
                    <button class="btn btn-outline-success boton-estiloCuadrado">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                  </div>
                </td>

                <!-- 🔢 N° SOL -->
                <td class="fw-semibold text-dark text-center">
                  <i class="bi bi-file-earmark-text me-1"></i>
                  {{ post.idMaeSolicitud }}
                </td>

                <!-- 🚦 ESTADO -->
                <td>
                  <span class="fw-semibold text-center label-resaltado" :class="{
                    'text-warning': post.solEstado == '001',
                    'text-primary': post.solEstado == '002',
                    'text-success': post.solEstado == '003',
                    'text-danger': post.solEstado == '004',
                    'text-secondary': post.solEstado == '005'
                  }">
                    <i :class="{
                      'bi bi-hourglass-split': post.solEstado == '001',
                      'bi bi-check-circle': post.solEstado == '003',
                      'bi bi-clock-history': post.solEstado == '002',
                      'bi bi-x-circle': post.solEstado == '004',
                      'bi bi-slash-circle': post.solEstado == '005'
                    }"></i>
                    {{ post.desEstado }}
                  </span>
                </td>

                <!-- 📅 Fecha -->
                <td class="text-center">
                  <i class="bi bi-calendar-check me-1 text-muted"></i>
                  {{ post.solFecRegistro.slice(0, 10) }}
                </td>

                <!-- 👤 Asignado -->
                <td class="text-start">
                  <i class="bi bi-person-workspace me-1 text-secondary"></i>
                  {{ post.responSeleccion || '—' }}
                </td>

                <!-- 📍 Lugar -->
                <td class="text-center">
                  <i class="bi bi-geo-alt-fill me-1 text-danger"></i>
                  {{ post.desUbigeo }}
                </td>

                <!-- 🏢 Empresa -->
                <td class="text-start">
                  <i class="bi bi-building-fill me-1 text-primary"></i>
                  {{ post.centroCosto }}
                </td>

                <!-- 💼 Cliente -->
                <td class="text-start">
                  <i class="bi bi-people me-1 text-info"></i>
                  {{ post.subCentroCosto }}
                </td>

                <!-- 🎯 Puesto -->
                <td class="text-start">
                  <i class="bi bi-person-badge-fill me-1 text-success"></i>
                  {{ post.nomPuesto }}
                </td>

                <!-- 👥 Cantidad -->
                <td class="text-start">
                  <i class="bi bi-123 me-1 text-dark"></i>
                  {{ post.solCanPostulante }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
        <button class="btn btn-outline-primary btn-sm" @click="pag = 1" :disabled="pag === 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>

        <button class="btn btn-outline-primary btn-sm" @click="pag--" :disabled="pag === 1">
          <i class="bi bi-chevron-left"></i>
        </button>

        <span class="pagination-info small">
          Página {{ pag }} de {{ totalPages1 }}
        </span>

        <button class="btn btn-outline-primary btn-sm" @click="pag++" :disabled="pag === totalPages1">
          <i class="bi bi-chevron-right"></i>
        </button>

        <button class="btn btn-outline-primary btn-sm" @click="pag = totalPages1" :disabled="pag === totalPages1">
          <i class="bi bi-chevron-double-right"></i>
        </button>
      </div>
    </div>

    <div class=" border border-1 rounded-3 p-3 mb-3 ">
      <!-- tabla  de abajo-->

      <div v-if="!SolicitudCargarDet" class="d-flex justify-content-end mt-2">
        <span for="" class="input-group-text mt-3 buscar-estiloCuadrado"> <i class="bi bi-search"></i></span>
        <input class="form-control form-control-lg w-25 mt-3 me-2 buscar-estiloCuadrado" type="text"
          aria-label=".form-control-lg example" placeholder="POR IDENTIDAD / APELLIDOS / NOMBRES" v-model="busqueda2"
          @input="Filtro2" />
      </div>

      <div class="table-responsive mx-2 mt-2">

        <div v-if="SolicitudCargarDet" class="w-full overflow-hidden mx-2 mt-5">
          <b-row class="mt-1">
            <b-col cols="12" class="mt-5">
              <b-skeleton-img no-aspect height="380px"></b-skeleton-img>
            </b-col>
          </b-row>
        </div>

        <div v-if="!SolicitudCargarDet">
          <table v-if="tabla2" class="table table-bordered">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th scope="col"><i class="bi bi-boxes"></i></th>
                <th scope="col">N° SOL.</th>
                <th scope="col">ESTADO</th>
                <th scope="col">F. SELECCIÓN</th>
                <th scope="col">D. IDENTIDAD</th>
                <th scope="col">APELLIDOS Y NOMBRES</th>
                <th scope="col">EMPRESA</th>
                <th scope="col">CLIENTE</th>
                <th scope="col">PUESTO</th>
                <th scope="col">ADJUNTO</th>
              </tr>
            </thead>
            <!-- .slice(NUM_RESULTS1 - 6, NUM_RESULTS1) -->
            <tbody v-for="(post, index) in paginatedRespuesta2" :key="index.id">
              <!-- v-if="filter(post)" -->
              <tr class="text-center align-middle reducirTamaño">

                <th scope="row" class="text-center tabla-estiloCompreso">
                  <div class="mx-2" @click="
                    listadoPostulante(post.idSolicitud, post.idPostulante)
                    ">
                    <button class="btn btn-outline-success boton-estiloCuadrado">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                  </div>
                </th>

                <td class="fw-semibold text-dark">
                  <i class="bi bi-file-earmark-text me-1"></i>
                  {{ post.idSolicitud }}
                </td>

                <!-- 🚦 Estado con ícono dinámico -->
                <td :class="{
                  'text-primary label-resaltado': post.codEstado == '001',  // En proceso
                  'text-danger label-resaltado': post.codEstado == '002',   // Rechazado
                  'text-warning label-resaltado': post.codEstado == '003',  // Pendiente
                }">
                  <i class="me-1" :class="{
                    'bi bi-arrow-repeat': post.codEstado == '001',       // En proceso
                    'bi bi-x-circle-fill': post.codEstado == '002',      // Rechazado
                    'bi bi-hourglass-split': post.codEstado == '003',    // Pendiente
                  }"></i>
                  {{ post.posEstado }}
                </td>

                <!-- 📅 Fecha de selección -->
                <td>
                  <i class="bi bi-calendar-check text-muted me-1"></i>
                  {{ post.fechaSel.slice(0, 10) }}
                </td>

                <!-- 🆔 Número de documento -->
                <td>
                  <i class="bi bi-person-vcard me-1 text-secondary"></i>
                  {{ post.nroDocumento }}
                </td>

                <!-- 👤 Nombre -->
                <td class="text-start">
                  <i class="bi bi-person-fill me-1 text-success"></i>
                  {{ post.nombre }}
                </td>

                <!-- 🏢 Centro de costos -->
                <td class="text-start">
                  <i class="bi bi-building-fill me-1 text-primary"></i>
                  {{ post.nomCentroCostos }}
                </td>

                <!-- 💼 Subcentro de costos -->
                <td class="text-start">
                  <i class="bi bi-people me-1 text-info"></i>
                  {{ post.nomSubCc }}
                </td>

                <!-- 🎯 Puesto -->
                <td class="text-start">
                  <i class="bi bi-person-badge-fill me-1 text-success"></i>
                  {{ post.nomPuesto }}
                </td>
                <!-- {{ post.adjunto }}      -->
                <!-- {{ post.adjunto.slice(45, post.adjunto.legth) }} -->
                <td v-if="post.adjunto != 1" class="text-center">
                  <a :href="url + post.adjunto.slice(45, post.adjunto.legth)" target="_blank">
                    <i class="bi bi-download"></i></a>
                </td>

                <td class="text-center" v-if="post.adjunto == 1">-</td>
              </tr>
            </tbody>
          </table>

          <table v-if="!tabla2" class="table table-bordered">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th scope="col"><i class="bi bi-boxes"></i></th>
                <th scope="col">N° SOL.</th>
                <th scope="col">ESTADO</th>
                <th scope="col">F. SELECCIÓN</th>
                <th scope="col">D. IDENTIDAD</th>
                <th scope="col">APELLIDOS Y NOMBRES</th>
                <th scope="col">EMPRESA</th>
                <th scope="col">CLIENTE</th>
                <th scope="col">PUESTO</th>
                <th scope="col">ADJUNTO</th>
              </tr>
            </thead>
            <!-- .slice(NUM_RESULTS1 - 6, NUM_RESULTS1) -->
            <tbody v-for="(post, index) in paginatedRespuesta2" :key="index.id">
              <!-- v-if="filter(post)" -->
              <tr class="text-center align-middle reducirTamaño">
                <th scope="row" class="text-center tabla-estiloCompreso">
                  <div class="mx-2" @click="
                    listadoPostulante(post.idSolicitud, post.idPostulante)
                    ">
                    <button class="btn btn-outline-success boton-estiloCuadrado">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                  </div>
                </th>

                <td class="fw-semibold text-dark">
                  <i class="bi bi-file-earmark-text me-1"></i>
                  {{ post.idSolicitud }}
                </td>

                <!-- 🚦 Estado con ícono dinámico y color -->
                <td :class="{
                  'text-primary label-resaltado': post.codEstado == '001',  // En proceso
                  'text-danger label-resaltado': post.codEstado == '002',   // Rechazado
                  'text-warning label-resaltado': post.codEstado == '003',  // Pendiente
                }">
                  <i class="me-1" :class="{
                    'bi bi-arrow-repeat': post.codEstado == '001',       // En proceso
                    'bi bi-x-circle-fill': post.codEstado == '002',      // Rechazado
                    'bi bi-hourglass-split': post.codEstado == '003',    // Pendiente
                  }"></i>
                  {{ post.posEstado }}
                </td>

                <!-- 📅 Fecha de selección -->
                <td>
                  <i class="bi bi-calendar-event text-muted me-1"></i>
                  {{ post.fechaSel.slice(0, 10) }}
                </td>

                <!-- 🆔 Número de documento -->
                <td>
                  <i class="bi bi-person-vcard me-1 text-secondary"></i>
                  {{ post.nroDocumento }}
                </td>

                <!-- 👤 Nombre del postulante -->
                <td class="text-start">
                  <i class="bi bi-person-fill me-1 text-success"></i>
                  {{ post.nombre }}
                </td>

                <!-- 🏢 Centro de costos -->
                <td class="text-start">
                  <i class="bi bi-building-fill me-1 text-primary"></i>
                  {{ post.nomCentroCostos }}
                </td>

                <!-- 💼 Subcentro de costos -->
                <td class="text-start">
                  <i class="bi bi-people me-1 text-info"></i>
                  {{ post.nomSubCc }}
                </td>

                <!-- 🎯 Puesto -->
                <td class="text-start">
                  <i class="bi bi-person-badge-fill me-1 text-success"></i>
                  {{ post.nomPuesto }}
                </td>
                <!-- {{ post.adjunto }}      -->
                <!-- {{ post.adjunto.slice(45, post.adjunto.legth) }} -->
                <td v-if="post.adjunto != 1" class="text-center">
                  <a :href="url + post.adjunto.slice(45, post.adjunto.legth)" target="_blank">
                    <i class="bi bi-download"></i></a>
                </td>

                <td class="text-center" v-if="post.adjunto == 1">-</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
        <!-- Ir a la primera página -->
        <button class="btn btn-outline-primary btn-sm" @click="pags = 1" :disabled="pags === 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>

        <!-- Retroceder -->
        <button class="btn btn-outline-primary btn-sm" @click="pags--" :disabled="pags === 1">
          <i class="bi bi-chevron-left"></i>
        </button>

        <!-- Texto -->
        <span class="pagination-info small">
          Página {{ pags }} de {{ totalPages2 }}
        </span>

        <!-- Avanzar -->
        <button class="btn btn-outline-primary btn-sm" @click="pags++" :disabled="pags === totalPages2">
          <i class="bi bi-chevron-right"></i>
        </button>

        <!-- Ir a la última página -->
        <button class="btn btn-outline-primary btn-sm" @click="pags = totalPages2" :disabled="pags === totalPages2">
          <i class="bi bi-chevron-double-right"></i>
        </button>
      </div>

    </div>


  </div>



</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SolimanologGestionarPostulante",

  data() {
    return {
      url: "https://apitopas.gruposolimano.com.pe/Documentos/CV/",

      filterField: "",
      filterField1: "",
      cerrarTable1: true,
      cerrarTable2: false,
      NUM_RESULTS: 10,
      NUM_RESULTS1: 10,
      pag: 1,
      pags: 1,
      paginaFinal: "",
      excelCarga: false,
      excelBien: false,
      excelSst: false,
      excelBienestar: null,
      excelSstDocumento: null,
      // retro: false,
      // avanzar: true,
      noAvanzar: false,
      noRetroceder: false,
      noAvanzar1: false,
      noRetroceder1: false,
      excel: null,
      permisoVisualizador: null,
      trabajador: null,
      Respuesta: [],
      busqueda: "",
      tabla1: true,
      Respuesta2: [],
      busqueda2: "",
      tabla2: true,
      abortController: null,
      fechaHoy: '',
      excelInduccion:false,
      excelInducc:[]

    };
  },
  created() {
    if (localStorage.getItem("idPerfil") == 10 || localStorage.getItem("idPerfil") == 9 || localStorage.getItem("idPerfil") == 12) {
      this.reporteBienestar();
    }

    if (localStorage.getItem("idPerfil") == 6) {
      this.reporte();
    }

    if (localStorage.getItem("idPerfil") == 9 || localStorage.getItem("idPerfil") == 12) {
      this.reporteSST();
    }
    
    if(localStorage.getItem("idPerfil") == 9 ){
      this.reporteInduccion()
    }

    this.obtenerFechaPeru()


  },
  mounted() {
    this.permisoVisualizador = localStorage.getItem("idPerfil");
    this.trabajador = localStorage.getItem("idTrabajdor");
  },

  computed: {
    ...mapGetters("solicitudesListado", [
      "Solicitud",
      "Solicitudes",
      "SolicitudCargar",
      "SolicitudCargarDet",
    ]),

    totalPages1() {
      const baseData = this.tabla1 ? this.Solicitud : this.Respuesta;
      return Math.ceil(baseData.length / this.NUM_RESULTS);
    },
    paginatedRespuesta() {
      const baseData = this.tabla1 ? this.Solicitud : this.Respuesta;
      const start = (this.pag - 1) * this.NUM_RESULTS;
      return baseData.slice(start, start + this.NUM_RESULTS);
    },

    // Tabla 2
    totalPages2() {
      const baseData = this.tabla2 ? this.Solicitudes : this.Respuesta2;
      return Math.ceil(baseData.length / this.NUM_RESULTS1);
    },
    paginatedRespuesta2() {
      const baseData = this.tabla2 ? this.Solicitudes : this.Respuesta2;
      const start = (this.pags - 1) * this.NUM_RESULTS1;
      return baseData.slice(start, start + this.NUM_RESULTS1);
    },
  },

  methods: {

    obtenerFechaPeru() {
      const ahora = new Date();

      // Usamos 'en-CA' (Canadá) porque devuelve el formato YYYY-MM-DD igual que ISO
      // Pero 'America/Lima' fuerza que la fecha sea siempre la de Perú
      this.fechaHoy = ahora.toLocaleDateString('en-CA', {
        timeZone: 'America/Lima'
      });
      
      // Resultado: "2026-02-19" (Exactamente lo que acepta un <input type="date">)
    },

    Filtro() {
      if (this.abortController) {
        this.abortController.abort();
        console.log("🟠 Solicitud anterior cancelada");
      }

      this.abortController = new AbortController();

      if (this.busqueda.length > 0) {
        this.tabla1 = false;
        this.Respuesta = [];

        const currentDni = this.busqueda; // Captura el valor actual de busqueda

        this.axios
          .get(
            `AccesoSolicitud/BusquedaSolicitud?idTrabajador=${this.trabajador}&busqueda=${currentDni}`,
            { signal: this.abortController.signal }
          )
          .then((response) => {
            // Verifica que el valor actual de busqueda sea igual al valor al que correspondía la respuesta
            if (currentDni === this.busqueda) {
              this.Respuesta = response.data;
              console.log(response.data);
            }
          })
          .catch((error) => {
            // Manejo de errores si es necesario
            console.log(error);
            this.pag = 1;
          });
      } else {
        this.tabla1 = true;
        this.pag = 1;
      }
    },

    Filtro2() {
      if (this.busqueda2.length > 0) {
        this.tabla2 = false;
        this.Respuesta2 = [];

        const currentDni = this.busqueda2; // Captura el valor actual de busqueda

        this.axios
          .get(
            `SolicitudPostulante/BusquedaPostulanteDetx?idTrabajador=${this.trabajador}&busqueda=${this.busqueda2}`
          )
          .then((response) => {
            // Verifica que el valor actual de busqueda sea igual al valor al que correspondía la respuesta
            if (currentDni === this.busqueda2) {
              this.Respuesta2 = response.data;
              console.log(response.data);
            }
          })
          .catch((error) => {
            // Manejo de errores si es necesario
            console.log(error);
            this.pags = 1;
          });
      } else {
        this.tabla2 = true;
        this.pags = 1;
      }
    },

    reporte() {
      this.excelCarga = false;
      this.axios
        .get("ReportesExcel/ReporteContrato", { responseType: "blob" })
        .then((response) => {
          this.excelCarga = true;
          this.excel = response.data;
          console.log(response.data);
        });
    },

    reporteSST() {
      this.excelBien = false;
      this.axios
        .get(`ReportesExcel/ReportePosCapacitados`, { responseType: "blob" })
        .then((r) => {
          this.excelSst = true;
          this.excelSstDocumento = r.data;
          console.log(r.data);
        });
    },

    reporteBienestar() {
      this.excelBien = false;
      this.axios
        .get("ReportesExcel/ReporteBienestar", { responseType: "blob" })
        .then((response) => {
          this.excelBien = true;
          this.excelBienestar = response.data;
          console.log(response.data);
        });
    },

    reporteInduccion() {
      this.excelInduccion = false;
      this.axios
        .get("ReportesExcel/ReporteInduccion", { responseType: "blob" })
        .then((response) => {
          this.excelInduccion = true;
          this.excelInducc = response.data;
          console.log(response.data);
        });
    },

    descargarExcelSST() {
      var fileURL = window.URL.createObjectURL(
        new Blob([this.excelSstDocumento])
      );
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", `ReporteSST_${this.fechaHoy}.xlsx`);
      document.body.appendChild(fileLink);

      fileLink.click();
    },

    descargarExcel() {
      var fileURL = window.URL.createObjectURL(new Blob([this.excel]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "ReporteContratos.xlsx");
      document.body.appendChild(fileLink);

      fileLink.click();
    },

    descargarExcelBienestar() {
      var fileURL = window.URL.createObjectURL(new Blob([this.excelBienestar]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", `ReporteMedico_${this.fechaHoy}.xlsx`);
      document.body.appendChild(fileLink);

      fileLink.click();
    },

     descargarExcelInduccion() {
      var fileURL = window.URL.createObjectURL(new Blob([this.excelInducc]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", `Reporte_Induccion_Faltantes_${this.fechaHoy}.xlsx`);
      document.body.appendChild(fileLink);

      fileLink.click();
    },

    listado(id) {
      console.log(id);
      this.$router.push("/gestionSolicitud/" + id);
    },

    listadoPostulante(id, usuario) {
      localStorage.setItem("solicitudXpostulante", usuario);
      this.$router.push("/gestionSolicitudPostulante/" + id);
    },

    retroceso() {
      if (this.NUM_RESULTS === 8) {
        this.noRetroceder = true;
      } else {
        this.NUM_RESULTS -= 6;
        this.pag -= 1;
        this.noAvanzar = false;
        this.noRetroceder = false;
      }
    },

    retroceso1() {
      if (this.NUM_RESULTS1 === 8) {
        this.noRetroceder1 = true;
      } else {
        this.NUM_RESULTS1 -= 6;
        this.pags -= 1;
        this.noAvanzar1 = false;
        this.noRetroceder1 = false;
      }
    },
    aumentar() {
      this.NUM_RESULTS += 8;
      this.pag += 1;
      if (this.NUM_RESULTS > 8) {
        this.noRetroceder = false;
      } else {
        this.noRetroceder = true;
      }
      if (this.NUM_RESULTS > this.Solicitud.length) {
        this.noAvanzar = true;
      }
    },

    aumentar1() {
      this.NUM_RESULTS1 += 8;
      this.pags += 1;
      if (this.NUM_RESULTS1 > 8) {
        this.noRetroceder1 = false;
      } else {
        this.noRetroceder1 = true;
      }
      if (this.NUM_RESULTS1 > this.Solicitud.length) {
        this.noAvanzar1 = true;
      }
    },
  },
};
</script>

<style scoped>
.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565C0;
}

.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.boton-estiloPag {
  border: 1px solid rgb(199, 199, 199);
  background-color: white;
  color: rgb(32, 32, 32);
  padding: 0.6rem 1rem;
  border-radius: 0;
}

.boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
  /* Cambia el cursor a una mano */
}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}

.label-resaltado {
  font-weight: 700;
  font-size: 0.65rem;
}
</style>
